import Btns from "../../components/btns/Btns";
import { useContext, useEffect, useState } from "react";
import { Link, useParams } from "react-router-dom";
import axios from "axios";
import AppContext from "../../context/AppContext";
import DOMPurify from "dompurify";
import Footer from "../../components/footer/Footer";


export default function DepartmentChil() {

    // btn set
    const [activeButton, setActiveButton] = useState(2);

    const buttons = [
        {
            id: 1,
            name_uz: 'Universitet haqida',
            name_ru: 'Об Университете',
            name_en: 'About University',
            link: '/about',
        },
        {
            id: 2,
            name_uz: 'Kafedralar',
            name_ru: 'Факультеты',
            name_en: 'Faculties',
            link: '/department',
        },
        {
            id: 3,
            name_uz: 'Markaz va boʻlimlar',
            name_ru: 'Центры и Отделы',
            name_en: 'Centers and other departments',
            link: '/departments',
        },
        {
            id: 4,
            name_uz: 'Rektorat',
            name_ru: 'Ректорат',
            name_en: 'University Rectorate',
            link: '/rektorat',
        },
        {
            id: 5,
            name_uz: 'Universitet ichki mehnat tartib qoidalar',
            name_ru: 'Кодекс внутреннего трудового порядка университета',
            name_en: 'BEHAVIORAL CODE',
            link: '/rules',
        },
        {
            id: 6,
            name_uz: 'Universitet odob-axloq qoidalari',
            name_ru: 'Кодекс поведения',
            name_en: 'BEHAVIORAL CODE',
            link: '/rulesEtika',
        },
        {
            id: 7,
            name_uz: 'Universitet nizomi',
            name_ru: 'Устав Университета',
            name_en: 'University charter',
            link: '/regulation',
        },
        {
            id: 8,
            name_uz: "Universitet tashkiliy tuzilmasi",
            name_ru: "Cтруктура Университета",
            name_en: "Structure of the University",
            link: "/tashkiliytuzilmasi"
        }
    ]

    const { leng } = useContext(AppContext);
    const { id } = useParams();
    const [data, setData] = useState([]);
    const [data2, setData2] = useState([]);

    // Obyekt ma'lumotlarini olish
    const getInfo = async () => {
        try {
            const response = await axios.get(`https://new.utu-ranch.uz/category/kafedrakontent/by-kafedra/${id}/`)
            setData(response.data)
        } catch (error) {
            console.error("Xatolik:", error);
        }
    }

    // Umumiy ma'lumotlarni olish
    const getData = async () => {
        try {
            const response = await axios.get(`https://new.utu-ranch.uz/category/kafedrashu/`)
            setData2(response.data)
        } catch (error) {
            console.error("Xatolik:", error);
        }
    }

    // Sahifa yuklanganida yoki `id` o'zgarganda `useEffect` bajariladi
    useEffect(() => {
        getData();
        getInfo();
    }, [id]) // `id` o'zgarganda `getInfo` qayta yuklanadi

    return (
        <>
            <div className="depChil">
                <Btns activeButton={activeButton} setActiveButton={setActiveButton} buttons={buttons} />
                <div className="depChil_main">
                    <div className="depChil_main_aside">
                        {
                            data2.map(item => (
                                <div key={item.id}>
                                    <Link to={`/department/${item.id}`}><p>{item[`name_${leng}`]}</p></Link>
                                    <ul>
                                        {
                                            item.children_kafedra.map(rr => (
                                                <Link key={rr.id} to={`/department/${rr.id}`}>
                                                    <li>{rr[`name_${leng}`]}</li>
                                                </Link>
                                            ))
                                        }
                                    </ul>
                                </div>
                            ))
                        }
                    </div>
                    <div className="saddasd">

                        {
                            data.map(item => (
                                <div className="depChil_main_infos" key={item.id}>
                                    <div className="depChil_main_infos_userInfo">
                                        <img src={item.image} alt="" />
                                        <div className="depChil_main_infos_userInfo_infos">
                                            <label htmlFor="">{item[`lavozim_${leng}`]}:</label>
                                            <h2>{item[`full_name_${leng}`]}</h2>
                                            <label htmlFor="">{leng === 'uz' ? "Kontakt:" : leng === 'ru' ? "Контакты:" : "Contacts:"}</label>
                                            <p>{item.kontakt}</p>
                                            <label htmlFor="">{leng === 'uz' ? "Email:" : leng === 'ru' ? "Электронная почта:" : ""}</label>
                                            <p>{item.pochta}</p>
                                        </div>
                                    </div>
                                    <p className='aboutPage_info' dangerouslySetInnerHTML={{ __html: DOMPurify.sanitize(item[`kafedra_malumotlari_${leng}`]) }}></p>
                                </div>
                            ))
                        }

                        {id === '19' && (
                            <div style={{ marginTop: 24 }}>
                                <h3 style={{ marginBottom: 8, fontFamily: '"Montserrat", sans-serif' }}>
                                    {leng === 'uz' ? 'Modul yo\'riqnomalari' : leng === 'ru' ? 'Модульные руководства' : 'Modular Guides'}
                                </h3>
                                <p style={{ margin: '0 0 12px', color: '#444', fontFamily: '"Montserrat", sans-serif' }}>
                                    {leng === 'uz' ? 'Quyida ushbu kafedra uchun modul yo\'riqnomalari keltirilgan. Har bir hujjatni ochish uchun tugmani bosing.'
                                    : leng === 'ru' ? 'Ниже представлены модульные руководства для данной кафедры. Нажмите кнопку, чтобы открыть документ.'
                                    : 'Below are the modular guides for this department. Click Open File to view each document.'}
                                </p>
                                
                                {/* Eski fayllar - UZ/EN */}
                                <h4 style={{ marginTop: 20, marginBottom: 12, fontSize: 18, fontWeight: 600, color: '#333', fontFamily: '"Montserrat", sans-serif' }}>
                                    {leng === 'uz' ? 'EN' : leng === 'ru' ? 'EN' : 'EN'}
                                </h4>
                                <div style={{ display: 'grid', gap: 12, marginBottom: 24 }}>
                                    {[
                                        { id: 1, name: '70712301 - Machine Engineering Technologies and Equipment', fileName: 'modular_guide_1.docx', fileNameUz: 'modular_guide_uz_1.docx' },
                                        { id: 2, name: '61010400 - Logistics', fileName: 'modular_guide_2.docx', fileNameUz: 'modular_guide_uz_2.docx' },
                                        { id: 3, name: '60720400 - Technological Machines and Equipment', fileName: 'modular_guide_3.docx', fileNameUz: 'modular_guide_uz_3.docx' },
                                        { id: 4, name: '60720400 - Automative Engineering', fileName: 'modular_guide_4.docx', fileNameUz: 'modular_guide_uz_4.docx' }
                                    ].map((file) => {
                                        const filePath = `/files/${encodeURIComponent(file.fileName)}`;
                                        return (
                                            <div key={file.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #e7e7e7', borderRadius: 8, padding: '10px 12px', background: '#fff' }}>
                                                <span style={{ fontWeight: 600, fontFamily: '"Montserrat", sans-serif' }}>
                                                    {file.name}
                                                </span>
                                                <a
                                                    href={filePath}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ padding: '8px 12px', background: '#0b63f6', color: '#fff', borderRadius: 6, textDecoration: 'none', fontWeight: 600, fontFamily: '"Montserrat", sans-serif' }}
                                                >
                                                    {leng === 'uz' ? 'Faylni ochish' : leng === 'ru' ? 'Открыть файл' : 'Open File'}
                                                </a>
                                            </div>
                                        );
                                    })}
                                </div>

                                {/* Yangi fayllar - UZ */}
                                <h4 style={{ marginTop: 20, marginBottom: 12, fontSize: 18, fontWeight: 600, color: '#333', fontFamily: '"Montserrat", sans-serif' }}>
                                    {leng === 'uz' ? 'UZ' : leng === 'ru' ? 'UZ' : 'UZ'}
                                </h4>
                                <div style={{ display: 'grid', gap: 12 }}>
                                    {[
                                        { id: 5, name: '60720400 – Texnologik mashinalar va uskunalar', fileName: '60720400 – Texnologik mashinalar va uskunalar.docx', fileNameUz: '60720400 – Texnologik mashinalar va uskunalar.docx' },
                                        { id: 6, name: '60720400 – Transport vositalari muhandisligi', fileName: '60720400 – Transport vositalari muhandisligi.docx', fileNameUz: '60720400 – Transport vositalari muhandisligi.docx' },
                                        { id: 7, name: '61010400 – Logistika', fileName: '61010400 – Logistika.docx', fileNameUz: '61010400 – Logistika.docx' },
                                        { id: 8, name: '70712301 – Mashinasozlik texnologiyalari va uskunalari', fileName: '70712301 – Mashinasozlik texnologiyalari va uskunalari.docx', fileNameUz: '70712301 – Mashinasozlik texnologiyalari va uskunalari.docx' }
                                    ].map((file) => {
                                        const filePath = leng === 'uz' 
                                            ? `/files/${encodeURIComponent(file.fileNameUz)}`
                                            : `/files/${encodeURIComponent(file.fileName)}`;
                                        return (
                                            <div key={file.id} style={{ display: 'flex', justifyContent: 'space-between', alignItems: 'center', border: '1px solid #e7e7e7', borderRadius: 8, padding: '10px 12px', background: '#fff' }}>
                                                <span style={{ fontWeight: 600, fontFamily: '"Montserrat", sans-serif' }}>
                                                    {file.name}
                                                </span>
                                                <a
                                                    href={filePath}
                                                    target="_blank"
                                                    rel="noreferrer"
                                                    style={{ padding: '8px 12px', background: '#0b63f6', color: '#fff', borderRadius: 6, textDecoration: 'none', fontWeight: 600, fontFamily: '"Montserrat", sans-serif' }}
                                                >
                                                    {leng === 'uz' ? 'Faylni ochish' : leng === 'ru' ? 'Открыть файл' : 'Open File'}
                                                </a>
                                            </div>
                                        );
                                    })}
                                </div>
                            </div>
                        )}
                    </div>
                </div>
            </div>
            <Footer />
        </>
    )
}